import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { GoCodescanCheckmark } from "react-icons/go";
import ClinicVisitScan from "./ClinicVisitScan";
import { FaSync, FaSyncAlt } from "react-icons/fa";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import Message from "./Message";
import { CLINIC_DETAILS_RESET } from "../constants/clinicConstants";
import ClinicCheckListForm from "./ClinicCheckListForm";

const ClinicChecklists = ({
  clinicCheckLists,
  setClinicChecklists,
  clinicId,
}) => {
  const [referesh, setReferesh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const addChecklist = () => {
    setClinicChecklists([
      ...clinicCheckLists,
      {
        idx: Math.random(),
        title: "",
        edit: true,
        subtitles: [],
      },
    ]);
  };

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  const updateClinicCheckLists = async () => {
    // update checkLists
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/clinics/${clinicId}/updateClinicCheckLists`,
        {
          clinicCheckLists,
        },
        config,
      );
      setClinicChecklists(data.updatedClinicCheckLists);
      dispatch({ type: CLINIC_DETAILS_RESET });

      setLoading(false);
      notify({
        title: "CheckLists Update Status",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setLoading(false);
      setError(message);
    }
  };
  return (
    <div>
      <h3>Routine Visit Check List</h3>

      <Button
        className="btn-secondary w-100 my-3"
        onClick={() => addChecklist()}
      >
        {" "}
        <GoCodescanCheckmark /> Add New CheckList
      </Button>
      {loading ? (
        <Skeleton height="150px" count={6} />
      ) : error ? (
        <Message children={error} variant={`danger`} setMessage={setError} />
      ) : (
        <>
          {clinicCheckLists
            ?.sort((a, b) => a.title?.localeCompare(b.title))
            .map((s) => (
              <div key={s.idx || s._id} className="my-3">
                <ClinicCheckListForm
                  referesh={referesh}
                  setReferesh={setReferesh}
                  clinicCheckLists={clinicCheckLists}
                  checklistItem={s}
                />
              </div>
            ))}
        </>
      )}

      {!loading && (
        <div className="d-flex justify-content-end width-100">
          <div>
            <Button
              variant="outline-info"
              onClick={() => updateClinicCheckLists()}
            >
              <FaSync /> Update
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClinicChecklists;
